import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=5f51d5d4&scoped=true&"
import script from "./TextComponent.vue?vue&type=script&lang=js&"
export * from "./TextComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=5f51d5d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51d5d4",
  null
  
)

export default component.exports